import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { BazowyComponent } from 'src/app/komponenty/bazowy.component';
import { TakNieModalComponent } from 'src/app/komponenty/ogolne/tak-nie-modal/tak-nie-modal.component';
import { KolumnaEwidencjiFiltrowanie } from 'src/app/modele/projekty/ewidencja/kolumnaEwidencjiFiltrowanie';
import { RodzajProjektu } from 'src/app/modele/projekty/rodzajProjektu';
import { EksportujDaneModel } from 'src/app/modele/projekty/spis/eksportujDaneModel';
import { KolumnaSpisuFiltrowanie } from 'src/app/modele/projekty/spis/kolumnaSpisuFiltrowanie';
import { PobierzSpisaneSrodkiCalegoProjektuFiltry } from 'src/app/modele/projekty/spis/pobierzSpisaneSrodkiCalegoProjektuFiltry';
import { PobierzSpisaneSrodkiLokalizacjiFiltry } from 'src/app/modele/projekty/spis/pobierzSpisaneSrodkiLokalizacjiFiltry';
import { UsunSrodkiModel } from 'src/app/modele/projekty/spis/usunSrodkiModel';
import { StatusProjektu } from 'src/app/modele/projekty/statusProjektu';
import { ModalOpcje } from 'src/app/modele/wspolne/modal-opcje.ogolne';
import { RejestrFiltrowanyRequest } from 'src/app/modele/wspolne/rejestrFiltrowanyRequest';
import { Routing } from 'src/app/modele/wspolne/routing';
import {
  Sortowanie,
  KierunekSortowania,
} from 'src/app/modele/wspolne/sortowanie';
import { Stronicowanie } from 'src/app/modele/wspolne/stronicowanie';
import { AuthService } from 'src/app/serwisy/ogolne/auth.service';
import { LoaderService } from 'src/app/serwisy/ogolne/loader.service';
import { EksportDanychService } from 'src/app/serwisy/projekty/eksport-danych.service';
import { SpisService } from 'src/app/serwisy/projekty/spis.service';

@Component({
  selector: 'app-spisane-srodki-calego-projektu',
  templateUrl: './spisane-srodki-calego-projektu.component.html',
  styleUrls: ['./spisane-srodki-calego-projektu.component.css'],
})
export class SpisaneSrodkiCalegoProjektuComponent
  extends BazowyComponent
  implements OnInit
{
  idProjektu: string;
  czyZaladowanoDane: boolean;
  calkowitaLiczbaElementow: bigint;
  rozmiarTabeli: number = 25;
  czyJestWiecejRekordow: boolean = true;
  czyPokazacMenuSortowanie: boolean;
  wyszukiwanie: RejestrFiltrowanyRequest<PobierzSpisaneSrodkiCalegoProjektuFiltry> =
    new RejestrFiltrowanyRequest<PobierzSpisaneSrodkiCalegoProjektuFiltry>();
  spisaneSrodki: Array<Array<string>> = new Array();
  kolumnyTabeli: Array<string> = new Array();
  czyPierwszeUruchomienie: boolean = true;
  nazwaProjektu: string;
  czyPokazanoWyszukiwarkeMobile: boolean;
  czyPokazanoPodmenu: boolean;
  kolumnaId: number;
  slideConfig = {
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: document.getElementsByClassName('btn__left'),
    nextArrow: document.getElementsByClassName('btn__right'),
    infinite: false,
    variableWidth: true,
    initialSlide: 3,
  };
  filtryZUrl: KolumnaSpisuFiltrowanie[] = new Array();
  statusProjektu: StatusProjektu;
  czyUsuwanieSrodkow: boolean;
  czyZaznaczonoWszystko: boolean;
  wybraneSrodki: Array<string> = new Array();
  czyAdministrator: boolean;
  kolumnaCzyMojSrodek: number;
  rodzajProjektu: RodzajProjektu;

  subsription: Subscription | undefined;
  czySpisSamodzielnyKlienta: boolean;

  constructor(
    public router: Router,
    modalService: NgbModal,
    loaderSerwis: LoaderService,
    komunikatSerwis: ToastrService,
    public authService: AuthService,
    public spisSerwis: SpisService,
    public translateSerwis: TranslateService,
    private activatedRoute: ActivatedRoute,
    public eksportDanychSerwis: EksportDanychService
  ) {
    super(
      authService,
      modalService,
      loaderSerwis,
      komunikatSerwis,
      router,
      translateSerwis
    );
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.czyAdministrator = this.czyAdmin();
      this.idProjektu = this.activatedRoute.snapshot.paramMap.get('idProjektu');
      this.wyszukiwanie.filtry = new PobierzSpisaneSrodkiCalegoProjektuFiltry();
      this.wyszukiwanie.sortowanie = new Sortowanie(
        'data_utworzenia',
        KierunekSortowania.asc
      );
      this.wyszukiwanie.stronicowanie = new Stronicowanie(false);
      this.wyszukiwanie.stronicowanie.iloscRekordow = this.rozmiarTabeli;
      this.wyszukiwanie.stronicowanie.rekordPoczatkowy = 0;
      this.wyszukiwanie.stronicowanie.strona = 1;
      this.wyszukiwanie.filtry.idProjektu = this.idProjektu;

      this.pobierzFiltryZUrl();
      this.pobierzDaneDoEkranu(true);
    });
  }

  pobierzDaneDoEkranu(zLadowaczem: boolean) {
    this.zapiszFiltryWUrl();

    this.subsription = this.spisSerwis
      .pobierzSpisaneSrodkiCalegoProjektu(this.wyszukiwanie, zLadowaczem)
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.spisaneSrodki = rezultat.element.dane;
          this.calkowitaLiczbaElementow =
            rezultat.element.calkowitaIloscRekordow;
          this.czyJestWiecejRekordow = rezultat.element.czyJestWiecejRekordow;
          this.kolumnyTabeli = rezultat.element.kolumny;
          this.nazwaProjektu = rezultat.element.nazwaProjektu;
          this.kolumnaId = this.kolumnyTabeli.indexOf('id');
          this.kolumnaCzyMojSrodek =
            this.kolumnyTabeli.indexOf('czy_moj_srodek');
          this.statusProjektu = rezultat.element.statusProjektu;
          this.rodzajProjektu = rezultat.element.rodzajProjektu;
          this.czySpisSamodzielnyKlienta =
            rezultat.element.czySpisSamodzielnyKlienta;

          if (
            this.spisaneSrodki.length == 0 &&
            !this.czyJestWiecejRekordow &&
            this.calkowitaLiczbaElementow > 0n
          ) {
            this.wyszukiwanie.stronicowanie.rekordPoczatkowy = 0;
            this.wyszukiwanie.stronicowanie.strona = 1;
            this.pobierzDaneDoEkranu(true);
            return;
          }
          if (this.czyPierwszeUruchomienie) {
            this.przygotujFiltry();
            this.czyPierwszeUruchomienie = false;
          }

          this.czyZaladowanoDane = true;
          this.anulujUsuwanieSrodkow();

          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      });
  }

  zmienRozmiarTabeli() {
    this.wyszukiwanie.stronicowanie.iloscRekordow = this.rozmiarTabeli;
    this.pobierzDaneDoEkranu(true);
  }

  pobierzNumerRekorduPoczatek() {
    if (this.wyszukiwanie.stronicowanie == undefined) {
      return 1;
    }
    return this.wyszukiwanie.stronicowanie.rekordPoczatkowy + 1;
  }
  pobierzNumerRekorduKoniec() {
    if (this.wyszukiwanie.stronicowanie == undefined) {
      return 1;
    }
    return (
      this.wyszukiwanie.stronicowanie.rekordPoczatkowy +
      this.spisaneSrodki.length
    );
  }

  zmienStrone(oIle: number) {
    this.wyszukiwanie.stronicowanie.strona += oIle;
    this.wyszukiwanie.stronicowanie.rekordPoczatkowy =
      (this.wyszukiwanie.stronicowanie.strona - 1) *
      this.wyszukiwanie.stronicowanie.iloscRekordow;
    this.pobierzDaneDoEkranu(true);
  }

  cofnij() {
    this.router.navigate([Routing.Spis, this.idProjektu]);
  }

  pobierzKierunekSortowania(kolumna: string) {
    var kierunki = this.wyszukiwanie.sortowanie.listaSortowania;

    var kierunek = kierunki.find((m) => m.nazwaKolumny == kolumna);

    if (kierunek == undefined) {
      return '';
    }

    if (kierunek.kierunekSortowania == KierunekSortowania.asc) {
      return 'up';
    }
    if (kierunek.kierunekSortowania == KierunekSortowania.desc) {
      return 'down';
    }
  }

  zmienKierunekSortowania(kolumna: string) {
    this.czyPokazacMenuSortowanie = false;
    var kierunki = this.wyszukiwanie.sortowanie.listaSortowania;

    var kierunek = kierunki.find((m) => m.nazwaKolumny == kolumna);

    if (kierunek == undefined) {
      this.wyszukiwanie.sortowanie = new Sortowanie(
        kolumna,
        KierunekSortowania.asc
      );
      this.pobierzDaneDoEkranu(true);
      return;
    }

    if (kierunek.kierunekSortowania == KierunekSortowania.asc) {
      this.wyszukiwanie.sortowanie = new Sortowanie(
        kolumna,
        KierunekSortowania.desc
      );
      this.pobierzDaneDoEkranu(true);
      return;
    }
    if (kierunek.kierunekSortowania == KierunekSortowania.desc) {
      this.wyszukiwanie.sortowanie = new Sortowanie(
        'id',
        KierunekSortowania.asc
      );
      this.pobierzDaneDoEkranu(true);
      return;
    }
  }

  wyczyscFiltry() {
    this.wyszukiwanie.filtry.kolumnyFiltrowania.forEach((k) => {
      k.wartoscSzukaj = '';
    });
    this.pobierzDaneDoEkranu(true);
  }

  filtrujPoTekscie(event: any, kolumna: string) {
    this.wyszukiwanie.stronicowanie.rekordPoczatkowy = 0;
    this.wyszukiwanie.stronicowanie.strona = 1;
    var wartosc = event.target.value.toString();

    this.ustawWartoscFiltrowania(kolumna, wartosc);

    this.subsription?.unsubscribe();

    this.pobierzDaneDoEkranu(false);
  }

  ustawWartoscFiltrowania(kolumna: string, wartosc: string) {
    var kolumnaFiltrowania = this.wyszukiwanie.filtry.kolumnyFiltrowania.find(
      (m) => m.kolumna == kolumna
    );

    if (kolumnaFiltrowania == undefined) {
      kolumnaFiltrowania = new KolumnaEwidencjiFiltrowanie();
      kolumnaFiltrowania.kolumna = kolumna;
      kolumnaFiltrowania.wartoscSzukaj = wartosc;
      this.wyszukiwanie.filtry.kolumnyFiltrowania.push(kolumnaFiltrowania);
    } else {
      this.wyszukiwanie.filtry.kolumnyFiltrowania.forEach((k) => {
        if (k.kolumna == kolumna) {
          k.wartoscSzukaj = wartosc;
        }
      });
    }
  }

  czyPokazacPrzyciskCzyszczeniaFiltru(kolumna: string) {
    var kolumnaFiltrowania = this.wyszukiwanie.filtry.kolumnyFiltrowania.find(
      (m) => m.kolumna == kolumna
    );
    return kolumnaFiltrowania != undefined && kolumnaFiltrowania.wartoscSzukaj;
  }
  wyczyscFiltrKolumny(kolumna: string) {
    this.wyszukiwanie.filtry.kolumnyFiltrowania.forEach((k) => {
      if (k.kolumna == kolumna) {
        k.wartoscSzukaj = '';
      }
    });
    this.pobierzDaneDoEkranu(false);
  }

  przygotujFiltry() {
    this.wyszukiwanie.filtry.kolumnyFiltrowania = new Array();
    this.kolumnyTabeli.forEach((kolumna) => {
      if (kolumna == 'id') {
        return;
      }
      var kolumnaFiltrowania = new KolumnaEwidencjiFiltrowanie();
      kolumnaFiltrowania.kolumna = kolumna;
      kolumnaFiltrowania.wartoscSzukaj =
        this.filtryZUrl.find((m) => m.kolumna == kolumna)?.wartoscSzukaj || '';
      this.wyszukiwanie.filtry.kolumnyFiltrowania.push(kolumnaFiltrowania);
    });
  }

  czyPokazacWyczyscFiltry() {
    return (
      this.wyszukiwanie.filtry.kolumnyFiltrowania.filter((m) => m.wartoscSzukaj)
        .length > 0
    );
  }
  pokazWyszukiwarkeMobile(czyPokazac: boolean) {
    this.czyPokazanoWyszukiwarkeMobile = czyPokazac;
    this.czyPokazanoPodmenu = false;
  }

  pokazPodmenu() {
    this.czyPokazanoPodmenu = !this.czyPokazanoPodmenu;
    this.czyPokazanoWyszukiwarkeMobile = false;
  }

  edytujSrodek(rekord: Array<string>) {
    var id = rekord[this.kolumnaId];
    if (this.czyUsuwanieSrodkow) {
      if (!this.czyMoznaZaznaczycSrodek(rekord)) {
        return;
      }
      if (this.wybraneSrodki.filter((m) => m == id).length) {
        this.czyZaznaczonoWszystko = false;
        this.wybraneSrodki = this.wybraneSrodki.filter((m) => m != id);
      } else {
        this.wybraneSrodki.push(id);
      }
      return;
    }

    this.router.navigate([Routing.EdycjaSrodka, this.idProjektu, id], {
      queryParams: this.budujQueryParams(),
      queryParamsHandling: '',
    });
  }

  budujQueryParams() {
    var filtry = this.wyszukiwanie?.filtry?.kolumnyFiltrowania
      ?.filter((m) => m.wartoscSzukaj)
      .map((m) => ({ [m.kolumna]: m.wartoscSzukaj }));

    return Object.assign(
      {},
      ...[
        { ['strona']: this.wyszukiwanie.stronicowanie.strona },
        { ['rozmiarStrony']: this.rozmiarTabeli },
        {
          ['sortowanieKolumna']:
            this.wyszukiwanie.sortowanie.listaSortowania[0].nazwaKolumny,
        },
        {
          ['sortowanieKierunek']:
            this.wyszukiwanie.sortowanie.listaSortowania[0].kierunekSortowania,
        },
        ...filtry,
      ]
    );
  }
  zapiszFiltryWUrl() {
    this.router.navigate([], {
      queryParams: this.budujQueryParams(),
      queryParamsHandling: '',
      replaceUrl: true,
      relativeTo: this.activatedRoute,
    });
  }

  pobierzFiltryZUrl() {
    var filtry = this.activatedRoute.snapshot.queryParamMap;

    this.wyszukiwanie.stronicowanie.rekordPoczatkowy =
      (this.wyszukiwanie.stronicowanie.strona - 1) *
      this.wyszukiwanie.stronicowanie.iloscRekordow;

    filtry.keys.forEach((k) => {
      if (
        [
          'strona',
          'rozmiarStrony',
          'sortowanieKolumna',
          'sortowanieKierunek',
        ].includes(k)
      ) {
        return;
      }
      var filtr = {
        kolumna: k,
        wartoscSzukaj: filtry.get(k),
      } as KolumnaSpisuFiltrowanie;
      this.wyszukiwanie.filtry.kolumnyFiltrowania.push(filtr);
      this.filtryZUrl.push(filtr);
    });

    this.wyszukiwanie.stronicowanie.strona =
      parseInt(filtry.get('strona')) || 1;
    this.rozmiarTabeli = parseInt(filtry.get('rozmiarStrony')) || 25;
    this.wyszukiwanie.stronicowanie.iloscRekordow = this.rozmiarTabeli;

    this.wyszukiwanie.stronicowanie.rekordPoczatkowy =
      (this.wyszukiwanie.stronicowanie.strona - 1) *
      this.wyszukiwanie.stronicowanie.iloscRekordow;

    this.wyszukiwanie.sortowanie.listaSortowania = [
      {
        kierunekSortowania: parseInt(filtry.get('sortowanieKierunek')) || 0,
        nazwaKolumny: filtry.get('sortowanieKolumna') || 'data_utworzenia',
      },
    ];
  }

  czyProjektZarchiwizowany() {
    return this.statusProjektu == StatusProjektu.zarchiwizowany;
  }

  usunSrodki() {
    if (this.wybraneSrodki.length == 0) {
      this.wyswietlKomunikat('Wybierz środki do usunięcia', true);
      return;
    }
    var model = new UsunSrodkiModel();
    model.srodkiId = this.wybraneSrodki;
    model.idProjektu = this.idProjektu;

    this.modalReference = this.modalService.open(
      TakNieModalComponent,
      new ModalOpcje(true, 'static')
    );
    this.modalReference.componentInstance.pytanie =
      'Czy na pewno chcesz usunąć wybrane środki?';

    this.modalReference.result.then(
      (result) => {
        if (result) {
          this.spisSerwis.usunSrodki(model).subscribe((rezultat) => {
            if (this.czyRezultatOk(rezultat)) {
              this.wyswietlKomunikat('Środki zostały usunięte');
              this.pobierzDaneDoEkranu(true);
              return;
            }

            this.wyswietlKomunikat(rezultat.wiadomosc, true);
            return;
          });
        }
      },
      (onRejected) => {}
    );
  }

  anulujUsuwanieSrodkow() {
    this.czyUsuwanieSrodkow = false;
    this.odznaczWszystko();
  }
  rozpocznijUsuwanieSrodkow() {
    this.czyUsuwanieSrodkow = true;
    this.odznaczWszystko();
  }

  zaznaczWszystko() {
    this.czyZaznaczonoWszystko = true;
    this.wybraneSrodki = new Array();
    this.spisaneSrodki.forEach((srodek) => {
      if (this.czyMoznaZaznaczycSrodek(srodek)) {
        this.wybraneSrodki.push(srodek[this.kolumnaId]);
      }
    });
  }

  odznaczWszystko() {
    this.czyZaznaczonoWszystko = false;
    this.wybraneSrodki = new Array();
  }

  srodekZmiana(e, id: string) {
    if (!e.target.checked) {
      this.czyZaznaczonoWszystko = false;
      this.wybraneSrodki = this.wybraneSrodki.filter((m) => m != id);
    } else {
      this.wybraneSrodki.push(id);
    }
  }

  czyWybranoSrodek(id: string) {
    return this.wybraneSrodki.filter((m) => m == id).length != 0;
  }

  pobierzId(rekord: Array<string>) {
    return rekord[this.kolumnaId];
  }

  czyMoznaZaznaczycSrodek(rekord: Array<string>) {
    if (this.czyAdministrator) {
      return true;
    }
    var czyMojSrodek = rekord[this.kolumnaCzyMojSrodek] == '1';

    return czyMojSrodek;
  }
}
